import React from 'react';

const UsersQueries = () => {
    return (
        <div>HI</div>
    )
}

export default UsersQueries